module.exports = __webpack_public_path__ + "img/ava_default.87d43019.png";